/* @flow */

import {useQuery} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetStagesets_stagesets as Stageset,
    GetStagesets as GetStagesetsQuery,
} from 'nutshell-graphql-types';

import GET_STAGESETS from '../queries/get-stagesets.graphql';

export const useGetStagesets = (): {
    isLoading: boolean,
    errorMessage: ?string,
    stagesets: Stageset[],
} => {
    const {loading, data, error} = useQuery<GetStagesetsQuery, {}>(GET_STAGESETS, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    return {
        isLoading: loading,
        errorMessage: safelyGetGraphQLErrorMessage(error),
        stagesets: data && data.stagesets ? data.stagesets : [],
    };
};
